import React from 'react';
import styles from './styles.module.css';
import {
  IoIosArrowBack,
  IoIosArrowDown,
  IoIosArrowUp,
  IoIosArrowForward,
} from 'react-icons/io';
import { Icon } from '../Icon';

export interface ArrowButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  color?: string;
  orientation?: 'right' | 'left' | 'up' | 'down';
  onClick: () => void;
  ariaLabel?: string;
}

const getCSSCustomProperty = (
  propertyName: string,
  fallback: string = ''
): string => {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    const defaultValues: Record<string, string> = {
      '--color-primary': '#5166B2',
    };
    return defaultValues[propertyName] || fallback;
  }

  const rootStyles = getComputedStyle(document.documentElement);
  return rootStyles.getPropertyValue(propertyName).trim() || fallback;
};

export const ArrowButton = ({
  orientation = 'right',
  onClick,
  color = getCSSCustomProperty('--color-primary', '#5166B2'),
  ariaLabel,
  ...rest
}: ArrowButtonProps) => {
  const orientationArrow = {
    right: <Icon icon={IoIosArrowForward} size={24} />,
    left: <Icon icon={IoIosArrowBack} size={24} />,
    up: <Icon icon={IoIosArrowUp} size={24} />,
    down: <Icon icon={IoIosArrowDown} size={24} />,
  };

  const ariaLabelDefaultText = {
    right: 'Seta para a direita',
    left: 'Seta para a esquerda',
    up: 'Seta para cima',
    down: 'Seta para a baixo',
  };

  const styledIcon = React.cloneElement(orientationArrow[orientation], {
    style: {
      fill: color,
    },
  });

  return (
    <button
      className={styles.button}
      style={
        {
          '--button-fill-color': color,
          '--button-fill-hover-color': color,
        } as React.CSSProperties
      }
      {...rest}
      aria-label={ariaLabel ? ariaLabel : ariaLabelDefaultText[orientation]}
    >
      {styledIcon}
    </button>
  );
};
